module.exports = {"categories":{"tools":"Σχεδιάστε χρήσιμα εργαλεία"}};